module.exports = __WEBPACK_EXTERNAL_MODULE_oidc_client__;